import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoGanttDataSourceMixin from './KendoGanttDataSourceMixin'

export default {
    name: 'kendo-ganttdatasource',
    mixins: [ KendoGanttDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDataSource/index.js